module.exports = __webpack_public_path__ + "static/media/POWER RANGERS TITLE.70d0a49a.jpg";